const ACTION = {
    UPDATE_CERTIFICATE_TYPE: 'UPDATE_CERTIFICATE_TYPE',
    UPDATE_CERTIFICATE_NUMBER: 'UPDATE_CERTIFICATE_NUMBER',
    UPDATE_CERTIFICATE_GROUP: 'UPDATE_CERTIFICATE_GROUP',
    UPDATE_CERTIFICATE_ERROR_TEXT: 'UPDATE_CERTIFICATE_ERROR_TEXT'
}

export default ACTION;